import React from "react";
import { Table, TableHeader, TableColumn, TableBody, TableRow, TableCell } from "@nextui-org/react";

function SidebarTable(props) {
  const formatData = (data) => {
    const displayData = [];

    if (data == {}) {
      return displayData;
    }

    Object.keys(data).forEach((key) => {
      if (key !== "total") {
        displayData.push({ label: key, value: data[key] });
      }
    });

    return displayData.sort((a, b) => b.value - a.value);
  };

  const displayData = formatData(props.data);

  return (
    <Table aria-label="Example static collection table">
      <TableHeader>
        <TableColumn className="text-base font-semibold">Total</TableColumn>
        <TableColumn className="text-base font-semibold">{props.data.total}</TableColumn>
      </TableHeader>
      <TableBody>
        {displayData.map((row) => (
          <TableRow key={row.label} className="h-[42px]">
            <TableCell className="text-base">{row.label}</TableCell>
            <TableCell className="text-base">{row.value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default SidebarTable;
